<template>
  <b-card
    v-if="tableData"
    no-body
    class="card-company-table"
  >
    <b-table
      :items="tableData"
      responsive
      :fields="fields"
      class="mb-0"
    >
      
      <template #cell(show_details)="row">
        <b-form-checkbox
          v-model="row.detailsShowing"
          plain
          class="vs-checkbox-con"
          @change="row.toggleDetails"
        >
          <span class="vs-checkbox">
            <span class="vs-checkbox--check">
              <i class="vs-icon feather icon-check" />
            </span>
          </span>
          <span class="vs-label">{{ row.detailsShowing ? 'Hide' : 'Show' }}</span>
        </b-form-checkbox>
      </template>

      <template #row-details="row">
        <b-card>
          <b-table
            :items="row.item.statistics"
            responsive
            :fields="['pageTitle', 'pageViews']"
            class=""
          >

            <!-- <template #cell(pageTitle)="data">
              <pre>{{data}}</pre>
            </template> -->
          </b-table>

          <div class="text-center" v-if="row.item.statistics.length === 0">
            <p>Data not found.</p>
          </div>

          <b-button
            size="sm"
            variant="outline-secondary"
            @click="row.toggleDetails"
          >
            Hide Details
          </b-button>
        </b-card>
      </template>

      <!-- company -->
      <template #cell(partner)="data">
        <div class="d-flex align-items-center">
          <b-avatar
            rounded
            size="48"
            variant="transparent"
            class="mr-1"
          >
            <b-img
              :src="data.item.partnerLogo"
              alt="avatar img"
              style="object-fit: contain; width: 48px"
            />
          </b-avatar>
          <div>
            <div class="font-weight-bolder">
              {{ data.item.partnerName }}
            </div>
          </div>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BTable, BAvatar, BImg, BFormCheckbox, BButton, } from 'bootstrap-vue';

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BImg,
    BFormCheckbox,
    BButton,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fields: [
        'show_details',
        { key: 'partner', label: 'PARTNER' },
        // { key: 'totalRevenue', label: 'REVENUE' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
